export default __webpack_public_path__ + "static/media/Inter-UI-SemiBold.a8fd51d2.woff2";